<template>
  <div>
    <add-institution-to-person-modal
      v-if="isPowerUserOrAdministrator"
      :show="showInstitutionModal"
      :person-id="linkedPersonId"
      @close="closeInstitutionModal"
    />

    <div>
      Liste des institutions
      <div v-if="institutionErrorMessage" class="validation-error mt-3">
        {{ institutionErrorMessage }}
      </div>
    </div>
    <div class="row text-left">
      <div class="col-md-12">
        <div class="card-body table-responsive table-full-width">
          <crud-list
            ref="crudList"
            :fetch-data="fetchInstitutions"
            :create-allowed="isPowerUserOrAdministrator && !editingDisabled"
            @row-clicked="institutionRowClicked"
            @create="createPersonInstitution"
          >
            <el-table-column label="Nom" min-width="20" property="name" />
            <el-table-column label="Acronyme" min-width="20">
              <div slot-scope="slotScope">
                {{ slotScope.row.acronym ? slotScope.row.acronym : '-' }}
              </div>
            </el-table-column>
            <el-table-column
              v-if="isPowerUserOrAdministrator && !editingDisabled"
              align="right"
              label="Action"
              min-width="20"
            >
              <div slot-scope="slotScope">
                <button
                  v-show="!editingDisabled"
                  type="button"
                  class="btn btn-icon btn-round btn-danger"
                  aria-label="Enlever l'institution"
                  @click="removePersonInstitution(slotScope.row, $event)"
                >
                  <i class="fa fa-minus" />
                </button>
              </div>
            </el-table-column>
          </crud-list>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isPowerUserOrAdministrator } from '@/services/AuthService';
import swal from 'sweetalert2';
import AddInstitutionToPersonModal from 'src/components/ApplicationViews/Modals/AddInstitutionToPersonModal.vue';
import CrudList from '../CrudList.vue';

export default {
  name: 'InstitutionsPersonList',
  components: {
    AddInstitutionToPersonModal,
    CrudList,
  },
  props: {
    editingDisabled: Boolean,
    linkedPersonId: Number,
  },
  data() {
    return {
      showInstitutionModal: false,
      institutionErrorMessage: null,
    };
  },
  computed: {
    isPowerUserOrAdministrator,
  },
  methods: {
    fetchInstitutions(pageNumber, pageSize) {
      return this.$http
        .get(
          `${
            process.env.VUE_APP_ANNUAIRE_API_URL
          }/institutionEntities/search/findByPersonId?personId=${
            this.linkedPersonId
          }&page=${pageNumber -
            1}&size=${pageSize}&projection=institutionListDTO`,
        )
        .then(response => ({
          records: response.data._embedded.institutionEntities
            ? response.data._embedded.institutionEntities
            : [],
          page: response.data.page,
        }));
    },
    institutionRowClicked(institution) {
      this.$router.push({
        name: 'InstitutionDetails',
        params: { id: institution.id, newInstitutionCreation: false },
      });
    },
    createPersonInstitution() {
      this.showInstitutionModal = true;
    },
    closeInstitutionModal() {
      this.showInstitutionModal = false;
      this.$refs.crudList.fetch();
    },
    removePersonInstitution(institution, event) {
      event.stopPropagation();

      this.institutionErrorMessage = null;

      swal({
        title:
          "Êtes-vous sûr de vouloir supprimer l'association entre cette personne et cette institution ?",
        text: "Il ne sera pas possible d'annuler cette suppression!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Oui, effacer',
        cancelButtonText: 'Non, conserver',
        buttonsStyling: false,
      }).then(() => {
        this.$http
          .delete(
            `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/people/${this.linkedPersonId}/institutions/${institution.id}`,
          )
          .then(response => {
            this.$refs.crudList.fetch();
          })
          .catch(error => {
            this.institutionErrorMessage =
              "Une erreur est survenue lors de la suppression de l'association entre la personne et l'institution, veuillez réessayer ou contacter le support.";
          });
      });
    },
  },
};
</script>

<style scoped></style>
